<template>
  <div class="home_box">
    <div class="content">
      <div class="banner">
        <img :src="banner" class="banner_img" id="home" />
      </div>

      <div class="gonggao">
        <b-container>
          <h1>公告：</h1>
          <p>{{ gonggao }}</p>
        </b-container>
      </div>
      <div class="case">
        <b-container>
          <div class="box1">
            <h1 id="case">热销商品</h1>
            <p>—Recommending Commodities—</p>
          </div>
          <b-tabs content-class="mt-3" justified class="tabbox">
            <b-tab
              class="tabbox1"
              :title="item.name"
              v-for="(item, index) in classify"
              :key="index"
              @click="changeClass(item)"
            >
              <div class="case_box2 row">
                <div
                  class="case_box3 col-4"
                  v-for="(item, index) in data"
                  :key="index"
                  @click="Details(item)"
                >
                  <div class="pox">
                    <img :src="item.navigation" class="case_img" />
                  </div>
                  <p>
                    {{ item.name }}
                  </p>
                  <span>{{ item.intro }}</span>
                </div>
              </div>
            </b-tab>
          </b-tabs>

          <div class="look" id="team">
            <b-button pill variant="outline-primary" class="look" @click="LookMore"
              >查看更多</b-button
            >
          </div>
        </b-container>
      </div>
      <div class="mt-8"></div>
      <div class="team">
        <b-container>
          <div class="box1">
            <h1>我们的团队</h1>
            <p>—OUR TEAM—</p>
          </div>
          <div class="team_box2 row">
            <div
              class="team_box3 col-lg-4 col-md-4 col-xs-6 col-sm-12"
              v-for="(item, index) in team"
              :key="index"
            >
              <img :src="item.avatar" />
              <p>职位：{{ item.position }}</p>
              <p>邮件：{{ item.username }}</p>
              <p>电话：{{ item.phone }}</p>
            </div>
          </div>
        </b-container>
      </div>
      <div class="advantage">
        <b-container>
          <h4>我们的优势</h4>
          <p>{{ advantage }}</p>
          <b-row>
            <b-col
              ><img src="../assets/icon_team1.png" class="img" />拥有专业销售人员</b-col
            >
            <b-col
              ><img src="../assets/icon_team2.png" class="img" />完善的服务体系</b-col
            >
            <b-col
              ><img src="../assets/icon_team3.png" class="img" />良好的售后支持</b-col
            >
          </b-row>
        </b-container>
      </div>
      <div class="flow">
        <b-container>
          <h6>服务流程</h6>
          <img src="../assets/server.png" class="img" />
        </b-container>
      </div>
    </div>

    <!-- <Footer id="call"></Footer> -->
  </div>
</template>
<script>
import axios from "axios";
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import local from "../utils/local";
import { index } from "../api/api";
export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      banner: "",
      advantage: "",
      team: "",
      data: [],
      gonggao: "",
      classify: [
        {
          name: "猪肉",
          value: "1",
        },
        {
          name: "牛肉",
          value: "2",
        },
        {
          name: "羊肉",
          value: "3",
        },
        {
          name: "鸡肉",
          value: "4",
        },
      ],
      type: "1",
    };
  },
  methods: {
    changeClass(data) {
      this.type = data.value;
      this.getInfo();
    },
    LookMore() {
      this.$router.push({
        path: "/case",
        query: {
          data: this.type,
        },
      });
    },

    getInfo() {
      index(this.type, 1, 9, 1).then((res) => {
        console.log(res);
        this.banner = res.data.data.msg[0].banner;
        this.advantage = res.data.data.par[0].advantage;
        this.team = res.data.data.team;
        this.data = res.data.data.instance.data;
        this.gonggao = res.data.data.par[0].content;
      });
    },
    Details(data) {
      this.$router.push({
        path: `/details`,
        query: {
          data: JSON.stringify(data),
        },
      });
    },
  },
  created() {
    this.getInfo();
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
};
</script>

<style lang="less" scoped="scoped">
.nav-tabs .active a {
  border-top: 2px solid #3498db !important;
  border-right: 1px solid #3498db !important;
  border-left: 1px solid #3498db !important;
}
.home_box {
  width: 100%;
  position: relative;
}

.banner {
  width: 100%;
  margin: 0 auto;

  .banner_img {
    width: 100%;
    height: 450px;
  }
}

.main {
  position: absolute;
}

.header {
  // position: absolute;
}

.pt-8 {
  margin-top: 80px;
}

.content {
  padding-top: 80px;

  // margin-top: 80px;
  // position: absolute;
}

.banner {
  width: 100%;
  margin: 0 auto;

  .banner_img {
    width: 100%;
    height: 450px;
  }
}

.box1 {
  text-align: center;

  h1 {
    font-size: 24px;
    font-weight: bold;
    color: #333;
  }

  p {
    font-size: 14px;
    color: #666;
    margin-bottom: 10px;
  }

  span {
    color: #808080;
  }
}

.gonggao {
  padding: 10px;
  h1 {
    text-align: center;
    font-size: 26px;
    font-weight: bold;
    color: red;
  }
  p {
    color: red;
  }
}
.case {
  background: #f9f9fb;
  padding-top: 80px;

  .tabbox {
    margin-top: 20px;
    border: none;
    .nav-tabs {
      background-color: coral !important;
    }
  }
  .row {
    margin: 0;
  }

  .case_box2 {
    margin-bottom: 50px;
    width: 100%;

    .col-4 {
      padding: 0;
    }

    .case_box3 {
      // width: 300px;
      margin-top: 80px;
      p {
        font-size: 16px;
        color: #333;
        line-height: 45px;
        margin: 0;
      }

      .pox {
        position: relative;
        width: 320px;
        height: 240px;

        .case_img {
          width: 320px;
          height: 240px;
        }

        .title {
          color: #2aa6fc;
        }

        .active {
          width: 100%;
          height: 240px;
          position: absolute;
          padding: 30px 10px;
          background: rgba(0, 0, 0, 0.5) !important;
          top: 0;
          left: 0;
          margin: 0;

          .col {
            text-align: center;

            p {
              color: #fff;
              z-index: 100;
            }

            .img {
              width: 110px;
              height: 110px;
            }
          }

          .btn {
            width: 120px;
          }
        }
      }

      span {
        font-size: 12px;
        color: #999;
      }
    }
  }

  .look {
    width: 100px;
    text-align: center;
    color: #28a6fc;
    font-size: 14px;
    margin: 0 auto;
    margin-bottom: 50px;
  }
}
.mt-8 {
  margin-top: 80px;
}
.team {
  .row {
    margin: 0;
  }

  .team_box2 {
    width: 100%;
    // display: flex;
    // flex-wrap: wrap;
    margin-top: 80px;

    .team_box3 {
      width: 25%;
      // text-align: center;

      img {
        width: 200px;
        height: 300px;
        object-fit: cover;
        margin-bottom: 20px;
      }

      h6 {
        font-size: 24px;
        color: #333;
        margin: 10px 0;
      }

      p {
        font-size: 14px;
        color: #666;
        margin-bottom: 10px;
      }
    }
  }
}

.advantage {
  padding: 0 50px;
  height: 320px;
  width: 100%;
  margin: 50px auto;
  background-image: url("../assets/bg_team.png");
  color: #fff;
  text-align: center;

  h4 {
    padding: 55px 0 15px 0;
    font-size: 24px;
  }

  p {
    font-size: 16px;
  }

  .row {
    margin-top: 80px;
    font-size: 16px;

    img {
      margin-right: 8px;
    }
  }
}

.flow {
  h6 {
    font-size: 24px;
    color: #668db1;
    text-align: center;
    margin: 80px 0;
  }

  .img {
    width: 100%;
  }
}
</style>
